import { createTrackerOptions } from '@/helpers/common';

export const VEHICLE_ALARM_IMMOBILISER = {
  N: 'None',
  M: 'Manufacturers Fitted',
  T1: 'Thatcham Category 1',
  T2: 'Thatcham Category 2',
  O: 'Other Alarm/Immobiliser',
};

export const VEHICLE_GREY_OR_IMPORT = {
  N: 'No',
  Y: 'European Import UK Spec',
  NU: 'European Import Non UK Spec',
  J: 'Japanese Import',
  U: 'US Import',
};

export const VEHICLE_IMMOBILISER = {
  Y: 'Manufacturer\'s Fitted',
  O: 'Other',
  N: 'No',
};

export const VEHICLE_KEPT = {
  R: 'On the Road',
  D: 'On a Private Driveway',
  G: 'In a Locked Garage',
  U: 'In an Unlocked Garage',
  P: 'Residential Parking',
  N: 'Non-Secure Car Park',
  S: 'Secure Car Park',
  C: 'Carport',
  RH: 'Road Away From Home',
  RP: 'Railway Car Park',
  W: 'Work Car Park',
  F: 'Forces Base Car Park',
};

export const VEHICLE_KEPT_FAVORITES = ['R', 'D', 'G'];

export const VEHICLE_KEPT_DAY = {
  H: 'At Home',
  W: 'Work Place Car Park',
  O: 'Open Public Car Park',
  S: 'Secure Public Car Park',
  SH: 'Street (Away From Home)',
};

export const VEHICLE_KEPT_DAY_FAVORITES = ['H', 'W', 'S'];

export const VEHICLE_TYPE_OF_USE = {
  4: 'Social & Commuting',
  5: 'Social Only',
  1: 'Business Use (by The Proposer)',
  6: 'Business Use by You and Spouse/Civil Partner',
  7: 'Business Use for All Drivers',
  8: 'Business Use by Spouse/Civil Partner',
  9: 'Commercial Travelling',
};
export const VEHICLE_TYPE_OF_USE_FAVORITES = [4, 5];
export const VEHICLE_TYPE_OF_USE_BUSINESS = [1, 6, 7, 8, 9];
export const VEHICLE_TYPE_OF_USE_OTHER = 'Social, Commuting & For Business';
export const VEHICLE_TYPE_OF_USE_REQUIRED_DRIVERS = [6, 7, 8];

export const MARITAL_STATUS = {
  M: 'Married',
  S: 'Single',
  D: 'Divorced',
  W: 'Widowed',
  C: 'Common Law Partner',
  V: 'Civil Partnership',
  T: 'Separated',
};

export const MARITAL_STATUS_FAVORITES = ['M', 'S', 'C'];

export const DRIVER_MARITAL_STATUS = {
  M: 'Married',
  S: 'Single',
  D: 'Divorced',
  W: 'Widowed',
  C: 'Common Law',
  V: 'Civil Partnership',
  T: 'Separated',
};
export const DRIVER_MARITAL_STATUS_FAVORITES = ['M', 'S', 'C'];

export const ADDITIONAL_RELATIONSHIP_PROPOSER = {
  S: 'Spouse',
  P: 'Parent',
  O: 'Son or Daughter',
  I: 'Brother or Sister',
  F: 'Other Family Member',
  C: 'Common Law Partner',
  V: 'Civil Partner',
  N: 'None',
};
export const ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES = ['S', 'P', 'C', 'N'];

export const DRIVER_ADDITIONAL_RELATIONSHIP_PROPOSER = {
  S: 'Spouse',
  P: 'Parent',
  O: 'Son or Daughter',
  I: 'Brother or Sister',
  C: 'Common Law Spouse',
  V: 'Civil Partner',
  N: 'None',
};
export const DRIVER_ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES = ['S', 'P', 'C', 'N'];

export const DRIVER_CHILDREN_MAX = 9;
export const DRIVER_CHILDREN_FAVORITES = [0, 1, 2, 3];
export const DRIVER_CHILDREN = (() => {
  const result = { 0: 'None' };
  [...Array(DRIVER_CHILDREN_MAX).keys()].forEach(n => {
    result[n + 1] = `${(n + 1).toString()} Child`;
    if ((n + 1) > 1) result[n + 1] += 'ren';
  });
  return result;
})();
export const DRIVER_CHILDREN_MORE_LABEL = 'More';

export const DRIVER_RESIDENTIAL_STATUS = {
  HO: 'Home Owner',
  L: 'Living With Parents',
  HA: 'Housing Association',
  O: 'Other',
};
export const RESIDENTIAL_STATUS_HOME_RENEWAL_REQUIRED = 'HO';

export const COVER_USE_OF_OTHER_VEHICLES = {
  X: 'No Access to Any Other Vehicles',
  N: "Named Driver on Another Person's Policy",
  O: 'Own/Use Another Car',
  M: 'Own/Use a Motorcycle',
  V: 'Own/Use a Van',
  S: 'Company Car (Including Social Domestic and Pleasure Use)',
  C: 'Company Car (Within Working Hours)',
};
export const COVER_NO_CLAIMS_BONUS_OTHER_REQUIRED = ['O', 'M', 'V', 'S'];

export const EMPLOYMENT_STATUS = {
  E: 'Employed',
  F: 'Full-Time Education',
  S: 'Self Employed',
  R: 'Retired',
  U: 'Unemployed',
  D: 'Director',
  P: 'Proprietor or Partner',
  H: 'Houseperson',
  I: 'Independent Means',
  N: 'Not Employed Due to Disability',
  G: 'Government',
  C: 'Club or Association',
  V: 'Voluntary Worker',
};

export const EMPLOYMENT_STATUS_FAVORITES = ['E', 'S', 'F', 'R'];

export const DRIVER_EMPLOYMENT_STATUS = {
  E: 'Employed',
  F: 'Full-Time Education',
  S: 'Self Employed',
  R: 'Retired',
  U: 'Unemployed',
  D: 'Director',
  P: 'Proprietor or Partner',
  H: 'Houseperson',
  I: 'Independent Means',
  N: 'Not Employed Due to Disability',
  G: 'Government',
  C: 'Club or Association',
};
export const DRIVER_EMPLOYMENT_STATUS_FAVORITES = ['E', 'S', 'F'];
export const DRIVER_EMPLOYMENT_STATUS_BUSINESS = ['E', 'F', 'S', 'D', 'P', 'G', 'C'];

export const DRIVER_TYPE_OF_DRIVING = {
  F: 'UK Full',
  P: 'UK Provisional',
  A: 'UK Automatic',
  EU: 'EU Full',
  EP: 'EU Provisional',
  O: 'Other European',
  M: 'International',
};
export const DRIVER_TYPE_OF_DRIVING_FAVORITES = ['F', 'P', 'A', 'EU'];
export const DRIVER_TYPE_OF_DRIVING_UK = ['F', 'P', 'A'];

export const DRIVER_LICENCE_YEARS_HELD = {
  0: 'Less than 1 Year',
  1: '1 Year ',
  2: '2 Years ',
  3: '3 Years ',
  4: '4 Years ',
  5: '5 Years ',
  6: '6 Years ',
  7: '7 Years ',
  8: '8 Years ',
  9: '9 Years ',
  10: '10 Years ',
  11: '11 Years ',
  12: '12 Years',
  13: '13 Years',
  14: '14 Years',
  15: '15 Years',
  16: '16 Years',
  17: '17 Years',
  18: '18 Years',
  19: '19 Years',
  20: '20 Years or more',
};

export const DRIVER_LICENCE_MONTHS_HELD = {
  0: 'Less than 1 Month',
  1: '1 Month',
  2: '2 Months',
  3: '3 Months',
  4: '4 Months',
  5: '5 Months',
  6: '6 Months',
  7: '7 Months',
  8: '8 Months',
  9: '9 Months',
  10: '10 Months',
  11: '11 Months',
};

export const DRIVER_MEDICAL_CONDITIONS = {
  N: 'No',
  NR: 'DVLA Aware - No Restrictions',
  Y: 'DVLA - Restricted 1 Year',
  YY: 'DVLA - Restricted 2 Years',
  YYY: 'DVLA - Restricted 3 Years',
  DU: 'DVLA Unaware',
  DA: 'Doctor Advised Not To Drive',
};

export const DRIVER_CLAIM_CAUSE_OF_DESCRIPTION = {
  A: 'Accident',
  F: 'Fire',
  O: 'Storm Damage',
  T: 'Theft',
  W: 'Windscreen/Glass',
  V: 'Vandalism',
};
export const DRIVER_CLAIM_CAUSE_OF_DESCRIPTION_FAVORITES = ['A', 'W', 'T'];

export const DRIVER_CLAIM_TYPE_THEFT = {
  VC: 'Vehicle and The Contents',
  C: 'Just The Contents of The Vehicle',
};

export const DRIVER_CLAIM_AT_FAULT = {
  C: 'Our Driver',
  O: 'Other Party',
  B: 'Both Parties',
  // N: 'No Other Vehicle Involved',
};

export const DRIVER_CONVICTION_ALCOHOL_LEVEL_REQUIRED_CODES = [
  'CD40',
  'CD60',
  'DR10',
  'DR20',
  'DR50',
  'DR40',
];

export const DRIVER_CONVICTION_ALCOHOL_METHOD_TEST = {
  B: 'Breath',
  L: 'Blood',
  U: 'Urine',
};

export const COVER_TYPE_OF_COVER = {
  1: 'Comprehensive',
  2: 'Third Party, Fire & Theft',
  3: 'Third Party Only',
};

export const COVER_TYPE_OF_COVER_DESCRIPTION = {
  1: 'Cover provided if your car’s damaged, stolen or written off. You’ll be covered for claims made against you by other people too.',
  2: 'If your car’s stolen, or damaged by fire, you can claim. You’re also covered for claims made against you by other people.',
  3: 'Cover for claims made against you by other people but there’s no cover for you or your car.',
};

export const COVER_NO_CLAIMS_BONUS = {
  0: 'No NCD',
  1: '1 Year',
  2: '2 Years',
  3: '3 Years',
  4: '4 Years',
  5: '5 Years',
  6: '6 Years',
  7: '7 Years',
  8: '8 Years',
  9: '9 Years',
  10: '10 Years',
  11: '11 Years',
  12: '12 Years',
  13: '13 Years',
  14: '14 Years',
  15: '15 Years',
  16: '16 Years',
  17: '17 Years',
  18: '18 Years',
  19: '19 Years',
  20: '20 Years or more',
};
export const COVER_NO_CLAIMS_BONUS_MAX = Math.max(...Object.keys(COVER_NO_CLAIMS_BONUS));
export const COVER_NO_CLAIMS_BONUS_MIN = Math.min(...Object.keys(COVER_NO_CLAIMS_BONUS));

export const COVER_VOLUNTARY_EXCESS = {
  0: 'None',
  50: '£ 50',
  100: '£ 100',
  150: '£ 150',
  200: '£ 200',
  250: '£ 250',
  300: '£ 300',
  350: '£ 350',
  400: '£ 400',
  450: '£ 450',
  500: '£ 500',
  550: '£ 550',
  600: '£ 600',
  650: '£ 650',
  700: '£ 700',
  750: '£ 750',
  800: '£ 800',
  850: '£ 850',
  900: '£ 900',
  950: '£ 950',
  1000: '£ 1000',
};

export const COVER_NUMBER_OF_OTHER_VEHICLES = {
  0: '0 vehicles',
  1: '1 vehicle',
  2: '2 vehicles',
  3: '3 vehicles',
  4: '4 vehicles',
  5: '5 vehicles',
  6: '6 vehicles',
  7: '7 vehicles',
  8: '8 vehicles',
  9: '9 vehicles',
};
export const COVER_NUMBER_OF_OTHER_VEHICLES_FAVORITES = [0, 1, 2, 3];

export const COVER_OWNER_OF_VEHICLE = [
  {
    value: 1,
    text: 'You (Policyholder)',
  },
  {
    value: 2,
    text: 'Spouse',
  },
  {
    value: 3,
    text: 'Parents',
  },
  {
    value: 4,
    text: 'Company',
  },
  {
    value: 5,
    text: 'Leased - Private',
  },
  {
    value: 10,
    text: 'Son or Daughter',
  },
  {
    value: 11,
    text: 'Other Family Member',
  },
  {
    value: 7,
    text: 'Common Law Partner',
  },
  {
    value: 8,
    text: 'Civil Partner',
  },
  {
    value: 9,
    text: 'Society or Club',
  },
  {
    value: 6,
    text: 'Other',
  },
];

export const COVER_REGISTERED_OF_VEHICLE = [
  {
    value: 1,
    text: 'You (Policyholder)',
  },
  {
    value: 2,
    text: 'Spouse',
  },
  {
    value: 3,
    text: 'Parents',
  },
  {
    value: 4,
    text: 'Company',
  },
  {
    value: 5,
    text: 'Leased - Private',
  },
  {
    value: 10,
    text: 'Son or Daughter',
  },
  {
    value: 11,
    text: 'Other Family Member',
  },
  {
    value: 7,
    text: 'Common Law Partner',
  },
  {
    value: 8,
    text: 'Civil Partner',
  },
  {
    value: 9,
    text: 'Society or Club',
  },
  {
    value: 6,
    text: 'Other',
  },
];

export const COVER_TYPE_EXPERIENCE = {
  N: 'No',
  D: 'Yes - As a Named Driver',
  B: 'Yes - Company Car (business use only)',
  S: 'Yes - Company Car (including social use)',
};

export const COVER_FREE_DRIVING = {
  0: 'Less than a year',
  1: '1 Year',
  2: '2 Years',
  3: '3 Years',
  4: '4 Years',
  5: '5 Years or more',
};

export const DRIVER_CONVICTION_POINTS_RECEIVED = {
  0: '0 Points',
  1: '1 Point',
  2: '2 Points',
  3: '3 Points',
  4: '4 Points',
  5: '5 Points',
  6: '6 Points',
  7: '7 Points',
  8: '8 Points',
  9: '9 Points',
  10: '10 Points',
  11: '11 Points',
  12: '12 Points',
};

export const VEHICLE_BODY_TYPES = {
  E: 'Estate',
  C: 'Cabriolet',
  O: 'Other', // TODO - fallback to Other if not empty
};

export const OPTIONAL_EXTRAS_OPTIONS = [{
  value: 'windscreen',
  trackerValue: 'windscreenCover',
  label: 'Windscreen cover',
},
{
  value: 'courtesy',
  trackerValue: 'courtesyCar',
  label: 'Courtesy car',
},
{
  value: 'breakdown',
  trackerValue: 'breakdownCover',
  label: 'Breakdown cover',
},
{
  value: 'accident',
  trackerValue: 'personalAccident',
  label: 'Personal accident',
  infoLabel: 'personal accident',
},
{
  value: 'legal',
  trackerValue: 'legalCover',
  label: 'Legal cover',
}];

export const OPTIONAL_EXTRAS_TRACKER_OPTIONS = createTrackerOptions(OPTIONAL_EXTRAS_OPTIONS);

export const CLAIMS_MAX_QTY = 5;
export const CONVICTIONS_MAX_QTY = 5;
export const DRIVERS_MAX_QTY = 5;

export const INSURER_MIN_AGE = 17;

export const CAUSE_OF_DESCRIPTION_ACCIDENT = 'A';
export const TYPE_THEFT_VEHICLE_CONTENTS = 'VC';
export const TYPE_THEFT_CONTENTS_OF_THE_VEHICLE = 'C';
export const CLAIM_SETTLED = true;

// TODO replace children related consts above after render components implementation
export const CHILDREN_MAX = 9;
export const CHILDREN_FAVORITES = [0, 1, 2, 3];
export const CHILDREN = (() => {
  const result = { 0: 'None' };
  [...Array(DRIVER_CHILDREN_MAX).keys()].forEach(n => {
    result[n + 1] = `${(n + 1).toString()} Child`;
    if ((n + 1) > 1) result[n + 1] += 'ren';
  });
  return result;
})();
